<button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative"
        style="width: 40px; height: 40px; border-radius: 50%; overflow: hidden; display: flex; justify-content: center; align-items: center;">
        <img *ngIf="profilePicDataUrl; else defaultAvatar" [src]="profilePicDataUrl" alt="User Profile Picture"
            style="width: 100%; height: 100%; object-fit: cover;">
        <ng-template #defaultAvatar>
            <mat-icon *ngIf="!showAvatar || !profilePicDataUrl" [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        </ng-template>
        <span class="absolute right-0 bottom-0 w-2 h-2 rounded-full" [ngClass]="{'mr-px mb-px': !showAvatar || !profilePicDataUrl,
                          'bg-green-500': user?.status === 'online',
                          'bg-amber-500': user?.status === 'away',
                          'bg-red-500': user?.status === 'busy',
                          'bg-gray-400': user?.status === 'not-visible'}"></span>
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>{{'user.signedInAs' | transloco}}</span>
            <span class="mt-1.5 text-md font-medium">{{userEmail}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="getProfile()">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>{{'user.profile' | transloco}}</span>
    </button>
    <button [hidden]="!this.domainSettingsEnabled" mat-menu-item (click)="getDomainSettings()">
        <mat-icon [svgIcon]="'heroicons_outline:globe-alt'"></mat-icon>
        <span>{{'user.domainSettings' | transloco}}</span>
    </button>
    <button [hidden]="!this.settingsEnabled" mat-menu-item (click)="getSettings()">
        <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
        <span>{{'user.settings' | transloco}}</span>
    </button>
    <button [hidden]="true" mat-menu-item [matMenuTriggerFor]="userStatus">
        <mat-icon [svgIcon]="'heroicons_outline:ellipsis-horizontal-circle'"></mat-icon>
        <span>Status</span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>{{'user.signOut' | transloco}}</span>
    </button>
</mat-menu>

<mat-menu class="user-status-menu" #userStatus="matMenu">
    <button mat-menu-item (click)="updateUserStatus('online')">
        <span class="w-4 h-4 mr-3 rounded-full bg-green-500"></span>
        <span>Online</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('away')">
        <span class="w-4 h-4 mr-3 rounded-full bg-amber-500"></span>
        <span>Away</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('busy')">
        <span class="w-4 h-4 mr-3 rounded-full bg-red-500"></span>
        <span>Busy</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('not-visible')">
        <span class="w-4 h-4 mr-3 rounded-full bg-gray-400"></span>
        <span>Invisible</span>
    </button>
</mat-menu>